export const MAX_WIDTH = '480px';
export const MIN_WIDTH = '320px';

export const DESTINATION: { [key: string]: string } = {
  DOMESTIC: '국내',
  OVERSEAS: '해외',
};

export const TERMS = [
  { term: '개인정보처리방침', isRequired: true },
  { term: '서비스 이용약관', isRequired: true },
  { term: '푸시 알림 동의', isRequired: false },
];

export const TERMS_PRIVACY = [
  {
    title: '제 1조 (목적)',
    value:
      'PACKIT(이하 ‘회사’라고 함)는 회사가 제공하고자 하는 서비스(이하 ‘회사 서비스’)를 이용하는 개인(이하 ‘이용자’ 또는 ‘개인’)의 정보(이하 ‘개인정보’)를 보고하기 위해, 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’) 등 관련 법령을 준수하고, 서비스 이용자의 개인정보 보호 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침(이하 ‘본 방침’)을 수립합니다.',
    type: 'text',
  },
  {
    title: '제 2조 (개인정보 처리의 원칙)',
    value:
      '개인정보 관련 법령 및 본 방침에 따라 회사는 이용자의 개인정보를 수집할 수 있으며 수집된 개인정보는 개인의 동의가 있는 경우에 한해 제 3자에게 제공될 수 있습니다. 단, 법령의 규정 등에 의해 적법하게 강제되는 경우 회사는 수집한 이용자의 개인정보를 사전에 개인의 동의 없이 제 3자에게 제공할 수도 있습니다.',
    type: 'text',
  },
  {
    title: '제 3조 (본 방침의 공개)',
    value: [
      '회사는 이용자가 언제든지 쉽게 본 방침을 확인할 수 있도록 회사 홈페이지 첫 화면 또는 첫 화면과의 연결화면을 통해 본 방침을 공개하고 있습니다.',
      '회사는 제 1항에 따라 본 방침을 공개하는 경우 글자 크기, 색상 등을 활용하여 이용자가 본 방침을 쉽게 확인할 수 있도록 합니다.',
    ],
    type: 'list',
  },
  {
    title: '제 4조 (본 방침의 변경)',
    value: [
      '회사는 이용자가 언제든지 쉽게 본 방침을 확인할 수 있도록 회사 홈페이지 첫 화면 또는 첫 화면과의 연결화면을 통해 본 방침을 공개하고 있습니다.',
      '회사는 제 1항에 따라 본 방침을 공개하는 경우 글자 크기, 색상 등을 활용하여 이용자가 본 방침을 쉽게 확인할 수 있도록 합니다.',
    ],
    type: 'list',
  },
  {
    title: '제 5조 (회원 가입을 위한 정보)',
    value: {
      explain:
        '회사는 이용자의 회사 서비스에 대한 회원가입을 위하여 다음과 같은 정보를 수집합니다.',
      content: ['필수 수집 정보: 닉네임', '선택 수집 정보: 프로필 사진'],
    },
    type: 'explain-list',
  },
  {
    title: '제 6조 (본인 인증을 위한 정보)',
    value: {
      content: ['필수 수집 정보: 닉네임, 본인확인값(CI)'],
    },
    type: 'explain-list',
  },
  {
    title: '제 7조 (회사 서비스 제공을 위한 정보)',
    value: {
      explain:
        '회사는 이용자에게 회사의 서비스를 제공하기 위하여 다음과 같은 정보를 수집합니다.',
      content: ['필수 수집 정보: 닉네임'],
    },
    type: 'explain-list',
  },
  {
    title: '제 8조 (서비스 이용 및 부정 이용 확인을 위한 정보)',
    value: {
      explain:
        '회사는 이용자에게 회사의 서비스를 제공하기 위하여 다음과 같은 정보를 수집합니다.',
      content: ['필수 수집 정보: 닉네임'],
      wordExplain:
        '*부정이용: 회원탈퇴 후 재 가입을 반복적으로 행위, 이용약관 등에서 금지하고 있는 행위, 명의도용 등의 불,편법행위 등을 말합니다. 수집되는 정보는 회사 서비스 이용에 따른 통계, 분석에 이용될 수 있습니다.',
    },
    type: 'explain-list',
  },
  {
    title: '제 9조 (개인정보 수집 방법)',
    value: {
      explain: '회사는 다음과 같은 방법으로 이용자의 개인정보를 수집합니다.',
      content: [
        '이용자가 회사의 홈페이지에 자신의 개인정보를 입력하는 방식',
        '어플리케이션 회사가 제공하는 홈페이지 외의 서비스를 통해 이용자가 자신의 개인정보를 입력하는 방식',
        '이용자가 회사가 발송한 이메일을 수신받아 개인정보를 입력하는 방식',
        '이용자가 고객센터의 상담, 게시판에서의 활동 등 회사의 서비스를 이용하는 과정에서 이용자가 입력하는 방식',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 10조 (개인정보의 이용)',
    value: {
      explain: '회사는 개인정보를 다음 각호 경우에 이용합니다.',
      content: [
        '이용자가 회사의 홈페이지에 자신의 개인정보를 입력하는 방식',
        '어플리케이션 회사가 제공하는 홈페이지 외의 서비스를 통해 이용자가 자신의 개인정보를 입력하는 방식',
        '이용자가 회사가 발송한 이메일을 수신받아 개인정보를 입력하는 방식',
        '이용자가 고객센터의 상담, 게시판에서의 활동 등 회사의 서비스를 이용하는 과정에서 이용자가 입력하는 방식',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 11조 (사전동의 등에 따른 개인정보의 제공)',
    value: {
      content: [
        '회사는 개인정보 제 3자 제공 금지에도 불구하고, 이용자가 사전에 공개하거나 다음 각호 사항에 대하여 동의한 경우에는 제 3자에게 개인정보를 제공할 수 있습니다.',
        '회사는 전향의 제 3자가 제공 관계에 변화가 있거나 제 3자가 제공 관계가 종결될 때도 같은 절차에 의해 이용자에게 고지 및 동의를 구합니다.',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 12조 (개인정보의 보유 및 이용기간)',
    value: {
      content: [
        '회사는 이용자의 개인정보에 대해 개인정보의 수집, 이용 목적이 달성을 위한 기간 동안 개인정보를 보유 및 이용합니다.',
        '전향에도 불구하고 회사는 내부 방침에 의해 서비스 부정이용기록은 부정 가입 및 이용 방지를 위하여 회원 탈퇴 시점으로부터 최대 1년간 보관합니다.',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 13조 (법령에 따른 개인정보의 보유 및 이용기간)',
    value: {
      explain: '회사는 관계법령에 따라 다음과 같이 개인정보를 보유 및 이용합니다.',
      content: [
        {
          value:
            '전자상거래 등에서의 소비자보호에 관한 법률에 따른 보유정보 및 보유기간',
          content: [
            '계약 또는 청약철회 등에 관한 기록: 5년',
            '대금결제 및 재화 등의 공급에 관한 기록: 5년',
            '소비자의 불만 또는 분쟁처리에 관한 기록: 3년',
            '표시, 광고에 관한 기록: 6개월',
          ],
        },
        {
          value: '통신비밀보호법에 따른 보유정보 및 보유기간',
          content: ['웹사이트 로그 기록 자료: 3개월'],
        },
        {
          value: '전자금융거래법에 따른 보유정보 및 보유기간',
          content: ['전자금융거래에 관한 기록: 5년'],
        },
        {
          value: '위치정보 보호 및 이용 등에 관한 법률',
          content: ['개인위치정보에 관한 기록: 6개월'],
        },
      ],
    },
    type: 'alpha-list',
  },
  {
    title: '제 14조 (개인정보의 파기원칙)',
    value:
      '회사는 원칙적으로 이용자의 개인정보 처리 목적의 달성, 보유, 이용기간의 경과 등 개인정보가 필요하지 않을 경우에는 해당 정보를 지체 없이 파기합니다.',
    type: 'text',
  },
  {
    title: '제 15조 (개인정보파기절차)',
    value: {
      content: [
        '이용자가 회원가입 등을 위해 입력한 정보는 개인정보 처리 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보 보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.',
        '회사는 파기 사유가 발생한 개인정보를 개인정보보호 책임자의 승인젗라를 거쳐 파기합니다.',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 16조 (개인정보파기방법)',
    value:
      '회사는 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제하며, 종이로 출력된 개인정보는 분쇄기로 분쇄하거나 소각 등을 통하여 파기합니다.',
    type: 'text',
  },
  {
    title: '제 17조 (개인정보 조회 및 수집동의 철회)',
    value: {
      content: [
        '이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 갸인정보수집 동의 철회를 요청할 수 있습니다.',
        '이용자 및 법정 대리인은 자신의 가입정보 수집 등에 대한 동의를 철회하기 위해서는 개인정보보호책임자 또는 담당자에게 서면, 전화 또는 전자우편주소로 연락하시면 회사는 지체 없이 조치하겠습니다.',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 18조 (개인정보 유출 등에 대한 조치)',
    value: {
      explain:
        '회사는 개인정보의 분실, 도난, 유출(이하 “유출 등”이라 한다) 사실을 안 때에는 지체 없이 다음 각 호의 모든 사항을 해당 이용자에게 알리고 방송통신위원회 또는 한국인터넷진흥원에 신고합니다.',
      content: [
        '유출 등이 된 개인정보 항목',
        '유출 등이 발생한 시점',
        '이용자가 취할 수 있는 조치',
        '정보통신서비스 제공자 등의 대응 조치',
        '이용자가 상담 등을 접할 수 있는 부서 및 연락처',
      ],
    },
    type: 'explain-list',
  },
  {
    title: '제 19조 (개인정보 유출 등에 대한 조치의 예외)',
    value:
      '회사는 전조에도 불구하고 이용자의 연락처를 알 수 없는 등 정당한 사유가 있는 경우에는 회사의 홈페이지에 30일 이상 게시하는 방법으로 전조의 통지를 갈음하는 조치를 취할 수 있습니다.',
    type: 'text',
  },
  {
    title: '제 20조 (회사의 개인정보 보호 책임자 지정)',
    value: {
      content: [
        {
          value:
            '회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호 책임자를 지정하고 있습니다.',
          content: [
            {
              value: '개인정보 보호 책임자',
              content: ['성명:', '전화번호:', '이메일:'],
            },
          ],
        },
      ],
    },
    type: 'rome-list',
  },
  {
    title: '제 21조 (부칙 : 시행일)',
    value: '본 약관은 2023년 12월 01일부터 효력이 발생됩니다.',
    type: 'text',
  },
];
